import { Link } from 'react-router-dom';
import { formatDisplayDate } from '../../utils';
import logoLight from '../../assets/images/icon-only-black.png';
import logoDark from '../../assets/images/icon-only-bronze.png';
import s from '../../styles/dashboard.module.css';

export function Header({ activeTab, setActiveTab, lightMode, toggleLightMode, time, lastFetch, isToday, selectedDate, onLogout, shareDeviceOnly = false }) {
  return (
    <header className={s.header} style={{ flexShrink: 0 }}>
      <span className={s.logo}>
        <img className={s.logoImg} src={lightMode ? logoLight : logoDark} alt="ACE CAR SPA" />
      </span>
      <nav className={s.nav}>
        <button className={`${s.navBtn} ${activeTab === 'queue' ? s.active : ''}`} onClick={() => setActiveTab('queue')}>Queue</button>
        {!shareDeviceOnly && (
          <>
            <button className={`${s.navBtn} ${activeTab === 'analytics' ? s.active : ''}`} onClick={() => setActiveTab('analytics')}>Analytics</button>
            <Link to="/transaction"><button className={`${s.navBtn}`}>Transactions</button></Link>
            <Link to="/staff"><button className={`${s.navBtn}`}>Staff</button></Link>
            <Link to="/admin"><button className={`${s.navBtn}`}>Admin</button></Link>
          </>
        )}
      </nav>
      <div className={s.headerRight}>
        <button onClick={() => toggleLightMode(l => !l)} className={s.themeSwitchBtn}>
          {lightMode ? 'Dark Mode' : 'Light Mode'}
        </button>
        <div className={s.headerClockGroup}>
          <span className={s.clock}>{time}</span>
          {lastFetch && <span className={s.headerSyncLabel}>{isToday ? `SYNCED ${lastFetch}` : `VIEWED ${formatDisplayDate(selectedDate)}`}</span>}
        </div>
        {onLogout && (
          <button onClick={onLogout} className={s.themeSwitchBtn}>Logout</button>
        )}
      </div>
    </header>
  );
}
